module.exports = __webpack_public_path__ + "img/sprite.6a4cf845.svg";